import { Container, Grid } from '@mui/material';
import {
  KioskConnectivityStatusIcon,
  KioskConnectivityStatusIconProps
} from '../kiosk-connectivity-status-icon/kiosk-connectivity-status-icon.component';
import { useKioskConnectivityStatusBarStyles } from './kiosk-connectivity-status-bar.styles';

export interface KioskConnectivityStatusBarProps {
  statuses: KioskConnectivityStatusIconProps[];
  message?: string;
}

export function KioskConnectivityStatusBar({ statuses, message }: KioskConnectivityStatusBarProps) {
  const classes = useKioskConnectivityStatusBarStyles();
  const inactiveKiosksStatuses = statuses.filter((u) => u.color === 'grey');

  return (
    <Container className={classes.wrapper}>
      <div className={classes.statusBar}>
        <Grid container spacing={1}>
          {statuses.map((status, i) =>
            status.color !== 'grey' ? (
              <Grid key={`statusGrid${i}`}>
                <KioskConnectivityStatusIcon {...status} />
              </Grid>
            ) : null
          )}
        </Grid>
        <div className={classes.message}>{message}</div>
        {inactiveKiosksStatuses.length > 0
          ? inactiveKiosksStatuses.map((status, index) => (
              <div key={index} className={classes.inactiveIcon}>
                <KioskConnectivityStatusIcon {...status} />
              </div>
            ))
          : null}
      </div>
    </Container>
  );
}
